export const transmittalCreationFormKeys = {
  TYPE: 'type',
};
